import * as angular from 'angular';

export default function SpendGraphHtmlDirective($sce, $filter) {
  'ngInject';

  var roundCurrency = $filter('roundCurrency');

  var defaultConfig = {
    chart: {
      css: {
        width: 250,
        height: 250
      }
    },
    legend: {
      enabled: true
    },
    cols: [
      {
        legend: {
          name: $sce.trustAsHtml('Continued Spend')
        },
        css: {
          backgroundColor: '#929396'
        },
        backgroundColorImage: '929396.gif', // Necessary to force printing bg colors
        amount: null
      },
      {
        legend: {
          name: $sce.trustAsHtml('<b>apt</b>itude Planned Spend')
        },
        css: {
          backgroundColor: '#000'
        },
        backgroundColorImage: '000.gif', // Necessary to force printing bg colors
        amount: null
      }
    ],
    header: {
      visible: true,
      css: {
        height: 45
      }
    },
    content: {
      css: {
        paddingTop: 20,
        height: 100
      }
    },
    footer: {
      css: {
        paddingTop: 5,
        height: 22,
        borderWidth: 2,
        borderColor: '#929396',
        fontSize: '16px',
        color: '#666'
      }
    }
  };

  return {
    restrict: 'EA',
    replace: true,
    template: require('./views/spendGraph.html'),
    scope: {
      data: '=stuff',
      sConfig: '=config'
    },
    controller: function ($scope) {
      'ngInject';

      function getContentHeight(config) {
        var headerCSS = config.header.css;
        var footerCSS = config.footer.css;
        var headerHeight = config.header.visible ? headerCSS.height : 0;
        var footerHeight =
          footerCSS.height + footerCSS.borderWidth + footerCSS.paddingTop;

        return (
          config.chart.css.height -
          config.content.css.paddingTop -
          headerHeight -
          footerHeight
        );
      }

      function setConfig(config) {
        config.content.css.height = getContentHeight(config);

        $scope.config = config;
        setData($scope.data);
      }

      function setData(data) {
        $scope.config.cols[0].amount = data.currentSpend;
        $scope.config.cols[1].amount = data.plannedSpend;

        setColumnHeight($scope.config);
      }

      function setColumnHeight(config) {
        // Get max amount - this could be optimized
        var maxAmount = 0;
        angular.forEach(config.cols, function (col) {
          maxAmount = Math.max(maxAmount, col.amount);
        });
        maxAmount /= 100; // convert it to a percent

        // Set the height as a percent of the max value
        angular.forEach(config.cols, function (col, key) {
          config.cols[key].css.height =
            Math.round(col.amount / maxAmount) + '%';
        });
      }

      setConfig(angular.copy(defaultConfig));

      $scope.$watch(
        'data',
        function (newVal) {
          setData($scope.data);
        },
        true
      );

      $scope.$watch('sConfig', function (newVal, oldVal) {
        var config = jQuery.extend(true, {}, defaultConfig, $scope.sConfig);

        setConfig(config);
      });
    }
  };
}
